export default __webpack_public_path__ + "static/pulzion21-3ca10499047e0eaef091ca80ef92943a.png";